import { Redirect, Route, Switch } from 'react-router-dom'
import { ForgotPassword } from './forgot-password'
import { ResetPassword } from './reset-password'
import { ActivateAccount } from './activate-account'
import { Login } from './login'
import LogoLogin from '../../images/Mall_Aventura.png'

export default function AuthPage() {

    return (
        <div className='d-flex flex-column flex-root'
        >
            <div className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
            >
                <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
                    {/* <a href='' className='mb-5'> */}
                    <div className="mb-12" id="logolink">
                        <img alt='Logo' src={LogoLogin} className='h-40px' />
                    </div>
                    {/* </a> */}
                    <div className="w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" 
                        style={{
                            display: "flex",
                            justifyContent: "center"
                        }}>
                        <Switch>
                            <Route path='/auth/login' component={Login} />
                            <Route path='/auth/forgotPassword' component={ForgotPassword} />
                            <Route path='/auth/resetPassword' component={ResetPassword} />
                            <Route path='/auth/activateAccount' component={ActivateAccount} />

                            <Redirect from='/auth' exact={true} to='/auth/login' />
                            <Redirect to='/auth/login' />
                        </Switch>
                    </div>
                </div>
           
            </div>
        </div>
    )
}
